/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Unless, When } from "react-if";
import { generatePath } from "react-router-dom";
import { Button, FlexContainer, theme } from "@nordcloud/gnui";
import { UnstyledLink } from "~/components";
import { ROUTES } from "~/routing/routes";
import { useCustomers } from "~/services/customers";

type Props = {
  accountId: string;
  isOnBoardLinkVisible: boolean;
  isSettingsLinkVisible: boolean;
};

export function AccountLinks({
  isOnBoardLinkVisible,
  isSettingsLinkVisible,
  accountId,
}: Props) {
  const { isAdminLite } = useCustomers();
  return (
    <FlexContainer columnGap={theme.spacing.spacing04}>
      <When condition={isOnBoardLinkVisible}>
        <UnstyledLink
          to={{
            pathname: ROUTES.accounts.add,
            search: `accountId=${accountId}&source=detail`,
          }}
        >
          <Button icon="edit">Onboard Account</Button>
        </UnstyledLink>
      </When>
      <Unless condition={isAdminLite}>
        <When condition={isSettingsLinkVisible}>
          <UnstyledLink to={generatePath(ROUTES.accounts.edit, { accountId })}>
            <Button icon="settings">Account Settings</Button>
          </UnstyledLink>
        </When>
      </Unless>
    </FlexContainer>
  );
}
